import { getStaticFileURL } from '@/shared/lib/image';
import { useTexture } from '@react-three/drei';
import { DoubleSide } from 'three';

export const WaterMark = () => {
	const texture = useTexture(getStaticFileURL('water-marks/3d.png'));

	return (
		<mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -1.25, 0]}>
			<planeGeometry args={[50, 50]} />
			<meshBasicMaterial transparent opacity={0.1} map={texture} side={DoubleSide} />
		</mesh>
	);
};
